import { lazy } from 'react';

export const LazyHomeSignPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--home-sign-page" */ './home-sign-page'
    ),
);
